import { useEffect } from "react";

import { Tracker } from "~utils/tracker";

const tracker = new Tracker({
    event: "Takeaways",
    action: "click",
});

const trackCarouselSwipe = (label: "click-fwd" | "click-back") => {
    tracker.trackEvent({
        category: "takeaways-nav",
        label,
    });
};

const MIN_SWIPE_DISTANCE = 50;

export function useGTMSwipeEffect({
    deps: [carouselRefState, isOpen],
}: {
    deps: [carouselRefState: HTMLDivElement | null, isOpen: boolean];
}) {
    useEffect(() => {
        if (!carouselRefState || !isOpen) return () => {};

        let touchStart = 0;
        let touchEnd = 0;

        const handleTouchStart = (event: TouchEvent) => {
            touchStart = event.targetTouches[0].clientX;
        };

        const handleTouchMove = (event: TouchEvent) => {
            touchEnd = event.targetTouches[0].clientX;
        };

        const handleTouchEnd = () => {
            const distance = touchStart - touchEnd;
            if (distance > MIN_SWIPE_DISTANCE) {
                trackCarouselSwipe("click-fwd");
            } else if (distance < -MIN_SWIPE_DISTANCE) {
                trackCarouselSwipe("click-back");
            }
        };

        carouselRefState.addEventListener("touchstart", handleTouchStart);
        carouselRefState.addEventListener("touchmove", handleTouchMove);
        carouselRefState.addEventListener("touchend", handleTouchEnd);

        return () => {
            carouselRefState.removeEventListener(
                "touchstart",
                handleTouchStart
            );
            carouselRefState.removeEventListener("touchmove", handleTouchMove);
            carouselRefState.removeEventListener("touchend", handleTouchEnd);
        };
    }, [isOpen, carouselRefState]);
}
